import customHeaders, { getSpace } from '../../common/headers';
import { OlegHttps } from '../../fetchUrls';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import {
  TableBox,
  Checkbox,
  ButtonBasic,
  DropDownSelector,
  RangeBox,
} from '@lk-gtcom/ecomlab-components';
import { ModalCreatingAnAdvertisingCampaignV2 } from '../../components/Modal/ModalCreatingAnAdvertisingCampaignV2/ModalCreatingAnAdvertisingCampaignV2';
import useGeneralStore from '../../store/general';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import './ListOfAdvertisingCampaigns.scss';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { options_prop_mp } from '../../common/globalVariables';
import { msToLocalDate } from '../../common/constant';
import { periodWeek } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  {
    label: 'Все',
    value: 'all_product',
  },
  {
    label: 'Активны',
    value: 'active',
  },
  {
    label: 'Не активны',
    value: 'disactive',
  },
  {
    label: 'Завершена',
    value: '_',
  },
  {
    label: 'Архивирована',
    value: '_',
  },
];

const ListOfAdvertisingCampaigns = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'list-advertising-campaigns');
  const requestControllerRef = useRef(new RequestController());

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'single' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'advCampaignType', type: 'multi' },
    { key: 'advStatus', type: 'multi' },
    { key: 'strategy', type: 'single' },
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [advCampaignTypeData, setAdvCampaignTypeData] = useState([]);
  const [advStatusData, setAdvStatusData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedAdvCampaignType, setSelectedAdvCampaignType] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedAdvStatus, setSelectedAdvStatus] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalAdvCampaignType, setTotalAdvCampaignType] = useState(0)
  const [totalAdvStatus, setTotalAdvStatus] = useState(0)

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [advCampaignTypePage, setAdvCampaignTypePage] = useState(1);
  const [advStatusPage, setAdvStatusPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [advCampaignTypeQuery, setAdvCampaignTypeQuery] = useState('');
  const [advStatusQuery, setAdvStatusQuery] = useState('');

  const [isWithStrategies, setIsWithStrategies] = useState(false)
  const navigate = useNavigate();

  // Дата
  const [date, setDate] = useState(periodWeek())
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const [pageValue, setPageValue] = useState(btn_tab[0].value);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

  const [isModalCreatingAnAdvertisingCampaign, setIsModalCreatingAnAdvertisingCampaign] = useState(false);
  const [currentStrategy, setCurrentStrategy] = useState(null);
  const [currentStrategyName, setCurrentStrategyName] = useState(null);
  const [currentStrategyNameForPortal, setCurrentStrategyNameForPortal] = useState(null);
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [isModalChoiceOfStrategy, setIsModalChoiceOfStrategy] = useState(false);
  const [total, setTotal] = useState(0);

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.advCampaignType) setSelectedAdvCampaignType(urlParams.advCampaignType)
        if (urlParams.advStatus) setSelectedAdvStatus(urlParams.advStatus)
        if (urlParams.strategy) setIsWithStrategies(urlParams.strategy?.value)
        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      advCampaignType: urlParams?.advCampaignType || selectedAdvCampaignType,
      advStatus: urlParams?.advStatus || selectedAdvStatus,
      strategy: urlParams?.strategy || isWithStrategies,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
    })
  }, [date, isReady]);

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!pageValue || !selectedApi?.value) {
      resetTable()
      return;
    }

    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `${OlegHttps}/api/v2/marketing/table/list_advertising_campaigns?in_auto_strategy=${isWithStrategies ? 'ON' : 'OFF'}`;

    let [date_from, date_to] = date;
    date_from = msToLocalDate(date_from);
    date_to = msToLocalDate(date_to);

    const body = JSON.stringify({
      campaign_id_list: ['all'],
      offer_id_list: ['all'],
      filters: filtersParam,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      date_from,
      date_to,
      state: btn_tab
        .filter((el) => el?.value === pageValue)
        .map((el) => el?.label)
        ?.join(''),
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      order_param: sort?.[0],
      order_param_direction: sort?.[1],
      adv_campaign_type_list: getValueMultiFilter(selectedAdvCampaignType),
      adv_status_list: getValueMultiFilter(selectedAdvStatus)
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal, })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad table response');
        }
      })
      .then((json) => {
        setTable(json);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  }

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  useEffect(() => {
    if (!isReady) return;
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [date, isWithStrategies, isTableRequest]);

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalApi,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      setTotal: setTotalApi,
      filter: 'api_id',
      dateFrom,
      dateTo,
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  }

  useEffect(() => {
    apiFilter()
  }, [isFilterRequest, apiPage, apiQuery, date]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      set: setCategoryData,
      searchParam: categoryQuery,
      setTotal: setTotalCategory,
      filter: 'category',
      dateFrom,
      dateTo,
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter()
  }, [isFilterRequest, categoryPage, categoryQuery, date]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedMarketplace,
      set: setBrandData,
      setTotal: setTotalBrand,
      filter: 'brand',
      dateFrom,
      dateTo,
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter()
  }, [isFilterRequest, brandPage, brandQuery, date]);


  const advCampaignTypeFilter = () => {
    const controller = requestControllerRef.current.createController('adv-campaign-type');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: advCampaignTypePage,
      searchParam: advCampaignTypeQuery,
      selectedShop: selectedMarketplace,
      set: setAdvCampaignTypeData,
      setTotal: setTotalAdvCampaignType,
      filter: 'campaign_type_advertising',
      dateFrom,
      dateTo,
    })?.finally(() => {
      requestControllerRef.current.removeController('adv-campaign-type');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    advCampaignTypeFilter()
  }, [isFilterRequest, advCampaignTypePage, advCampaignTypeQuery, date]);

  const advStatusFilter = () => {
    const controller = requestControllerRef.current.createController('adv-status');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: advStatusPage,
      searchParam: advStatusQuery,
      selectedShop: selectedMarketplace,
      set: setAdvStatusData,
      setTotal: setTotalAdvStatus,
      filter: 'status_advertising',
      dateFrom,
      dateTo,
    })?.finally(() => {
      requestControllerRef.current.removeController('adv-status');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    advStatusFilter()
  }, [isFilterRequest, advStatusPage, advStatusQuery, date]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  const onRedirect = (e) => {
    const [dataObj, el, header] = e;
    const { ID, Магазин, api_id } = dataObj || {};
    const [name] = el;
    if (header === 'Название кампании') {
      navigate(
        `/marketing-place/products-in-campaign/participate_items?campaignName=${name}&campaignId=${ID}&apiName=${Магазин}&apiId=${api_id}`
      );
    }
  };

  const onActionHandler = (el) => {
    setCheckedProducts(el.ID);
    setIsModalCreatingAnAdvertisingCampaign(true);
  };

  return (
    <>
      {isModalCreatingAnAdvertisingCampaign && (
        <ModalCreatingAnAdvertisingCampaignV2
          isEdit={true}
          dataTable={checkedProducts}
          selectedApi={selectedApi}
          selectedMarketplace={selectedMarketplace}
          selectedBrand={selectedBrand}
          selectedCategory={selectedCategory}
          currentStrategy={currentStrategy}
          currentStrategyName={currentStrategyName}
          currentStrategyNameForPortal={currentStrategyNameForPortal}
          setIsModalChoiceOfStrategy={(e) => setIsModalChoiceOfStrategy(e)}
          isModalChoiceOfStrategy={isModalChoiceOfStrategy}
          setIsModal={(e) => setIsModalCreatingAnAdvertisingCampaign(e)}
          tableDate={date}
          setDataTable={(e) => setCheckedProducts(e)}
          tablePageValue={pageValue}
        />
      )}

      <div className="list-of-advertising-campaigns">
        <TitlePage
          title='Список рекламных кампаний'
        />

        <div className="filter-and-btn">
          <FilterContainer
            loading={isSaved}
            saveFilters={saveFilters}
            clearSavedFilters={clearSavedFilters}
            hasSavedFilters={hasSavedFilters}
            onReset={(e) => {
              setSelectedMarketplace([])
              setSelectedApi([]);
              setSelectedCategory([]);
              setSelectedBrand([]);
              setSelectedAdvCampaignType([])
              setSelectedAdvStatus([])
              updateURL({
                mp: null,
                api: null,
                category: null,
                brand: null,
                advCampaignType: null,
                advStatus: null,
              });
              setIsTableRequest(!isTableRequest)
              setIsFilterRequest(!isFilterRequest)
            }}
          >
            <DropDownSelector
              options_prop={options_prop_mp}
              state={selectedMarketplace}
              setState={(e) =>
                setSelectedMarketplace(Array.isArray(e) ? e : [e])
              }
              placeholder="Маркетплейс"
              total={options_prop_mp?.length}
              onBlur={() => {
                updateURL({ mp: selectedMarketplace });
                apiFilter()
                brandFilter()
                categoryFilter()
                advCampaignTypeFilter()
                advStatusFilter()
                setIsTableRequest(!isTableRequest)
              }}
              multi
            />

            <DropDownSelector
              options_prop={apiData}
              state={selectedApi}
              setState={setSelectedApi}
              placeholder="Площадка"
              total={totalApi}
              fetchCallback={setApiPage}
              setInputChange={setApiQuery}
              onBlur={() => {
                updateURL({ api: selectedApi });
                brandFilter()
                categoryFilter()
                advCampaignTypeFilter()
                advStatusFilter()
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={categoryData}
              state={selectedCategory}
              setState={setSelectedCategory}
              placeholder="Категория"
              total={totalCategory}
              fetchCallback={setCategoryPage}
              setInputChange={setCategoryQuery}
              multi
              onBlur={() => {
                updateURL({ category: selectedCategory });
                brandFilter()
                advCampaignTypeFilter()
                advStatusFilter()
                setIsTableRequest(!isTableRequest)
              }}
            />
            <DropDownSelector
              options_prop={brandData}
              state={selectedBrand}
              setState={setSelectedBrand}
              placeholder="Бренд"
              total={totalBrand}
              fetchCallback={setBrandPage}
              setInputChange={setBrandQuery}
              multi
              onBlur={() => {
                updateURL({ brand: selectedBrand });
                advCampaignTypeFilter()
                advStatusFilter()
                setIsTableRequest(!isTableRequest)
              }}
            />
            <DropDownSelector
              options_prop={advCampaignTypeData}
              state={selectedAdvCampaignType}
              setState={(e) => setSelectedAdvCampaignType(e)}
              placeholder="По типу рекламной кампании"
              total={totalAdvCampaignType}
              fetchCallback={(e) => setAdvCampaignTypePage(e)}
              setInputChange={(e) => setAdvCampaignTypeQuery(e)}
              multi
              onBlur={() => {
                updateURL({ advCampaignType: selectedAdvCampaignType });
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={advStatusData}
              state={selectedAdvStatus}
              setState={(e) => setSelectedAdvStatus(e)}
              placeholder="По статусу рекламной кампании"
              total={totalAdvStatus}
              fetchCallback={(e) => setAdvStatusPage(e)}
              setInputChange={(e) => setAdvStatusQuery(e)}
              multi
              onBlur={() => {
                updateURL({ advStatus: selectedAdvStatus });
                setIsTableRequest(!isTableRequest)
              }}
            />
          </FilterContainer>

          <Checkbox
            value={isWithStrategies}
            onChange={(e) => {
              updateURL({
                strategy: {
                  label: e,
                  value: e
                }
              });
              setIsWithStrategies(e)
            }}
          >Со стратегией</Checkbox>

          <RangeBox
            date={date}
            setDate={(e) => {
              const [newDateFrom, newDateTo] = e;
              updateURL({
                date_from: newDateFrom,
                date_to: newDateTo
              });
              setDate(e)
            }}
          />
        </div>

        <TableBox
          {...tableProps}
          onRedirectInfo={true}
          paginator={true}
          ref={paginatorRef}
          onRedirect={onRedirect}
          fetchCallback={fetchTableData}
          onAction={(e) => onActionHandler(e)}
          statistic={[
            {
              label: 'Всего кампаний:',
              sum: total,
            },
          ]}
          child={
            <>
              <ButtonBasic
                green
                text="Создать рекламную кампанию"
                width="232px"
                size="32px"
                onClick={(e) =>
                  navigate(
                    '/create-campaign-from-rules'
                  )
                }
              />
              {/* <ButtonBasic
                green
                text="Cоздать кампанию из правил"
                width="232px"
                size="32px"
                onClick={(e) => { }}
              /> */}
            </>
          }
        />
      </div>
    </>
  );
};

export { ListOfAdvertisingCampaigns };
